import { render, staticRenderFns } from "./AClinica.vue?vue&type=template&id=7adb891e&"
import script from "./AClinica.vue?vue&type=script&lang=js&"
export * from "./AClinica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports